// extracted by mini-css-extract-plugin
export const item = "CruiseItineraryItem-module--item--1w4gp";
export const dayNumber = "CruiseItineraryItem-module--day-number--jACUh";
export const portImageContainer = "CruiseItineraryItem-module--port-image-container--SPfdc";
export const details = "CruiseItineraryItem-module--details--1TzYn";
export const overnightIcon = "CruiseItineraryItem-module--overnight-icon--ErToU";
export const portImage = "CruiseItineraryItem-module--port-image--1oPPQ";
export const dateTime = "CruiseItineraryItem-module--date-time--36SQ2";
export const name = "CruiseItineraryItem-module--name--rsFcP";
export const stopName = "CruiseItineraryItem-module--stop-name--xNeNm";
export const expand = "CruiseItineraryItem-module--expand--EmSej";
export const stopNameInline = "CruiseItineraryItem-module--stop-name-inline--gcGJZ";
export const stopWorldLocation = "CruiseItineraryItem-module--stop-world-location--2pSu6";
export const excursions = "CruiseItineraryItem-module--excursions--3NqgG";